import React, { useState, useEffect } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { publicAPI } from '../../services/api';
import { FiMenu, FiX, FiUser, FiSearch } from 'react-icons/fi';
import './Header.css';

const Header = () => {
  const [logoUrl, setLogoUrl] = useState(null);
  const [headerBg, setHeaderBg] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Pedimos el logo configurado para el 'header'
        const logoResponse = await publicAPI.getLogos('header');
        if (logoResponse.data && logoResponse.data.length > 0) {
          setLogoUrl(logoResponse.data[0].file_path);
        }

        // Pedimos las imágenes extra del header
        const imagesResponse = await publicAPI.getHeaderImages();
        if (imagesResponse.data && imagesResponse.data.length > 0) {
          setHeaderBg(imagesResponse.data[0].file_path);
        }
      } catch (error) {
        console.error('Error cargando datos del header:', error);
      }
    };

    fetchData();
  }, []);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      navigate(`/buscar?q=${encodeURIComponent(searchTerm)}`);
      setIsMenuOpen(false); // Cerrar menú móvil si está abierto
    }
  };

  return (
    <header className="header" style={{ backgroundImage: headerBg ? `url(${headerBg})` : 'none' }}>
      <div className="header-container">
        <Link to="/" className="logo-container">
          {logoUrl ? (
            <img src={logoUrl} alt="IMDI" className="logo-img" />
          ) : (
            <span className="logo-text">IMDI</span>
          )}
        </Link>

        <form className="search-bar" onSubmit={handleSearch}>
          <input 
            type="text" 
            placeholder="Buscar repuestos..." 
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <button type="submit"><FiSearch /></button>
        </form>

        <button className="mobile-menu-btn" onClick={toggleMenu}>
          {isMenuOpen ? <FiX /> : <FiMenu />}
        </button>

        <nav className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
          <NavLink to="/" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} onClick={() => setIsMenuOpen(false)}>Inicio</NavLink>
          <NavLink to="/nosotros" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} onClick={() => setIsMenuOpen(false)}>Nosotros</NavLink>
          <NavLink to="/marcas" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} onClick={() => setIsMenuOpen(false)}>Marcas</NavLink>
          <NavLink to="/contacto" className={({ isActive }) => isActive ? "nav-link active" : "nav-link"} onClick={() => setIsMenuOpen(false)}>Contacto</NavLink>
          <Link to="/login" className="nav-link login-link" onClick={() => setIsMenuOpen(false)}>
            <FiUser /> Acceso
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;